import React, { useEffect, useState } from "react";
import { Alert, FormControl } from "@mui/material";
import {
  BusinessCenterOutlined,
  FastfoodOutlined,
  MicExternalOnOutlined,
  NightlifeOutlined,
  SportsBasketballOutlined,
  TheaterComedy,
  VolunteerActivismOutlined,
} from "@mui/icons-material";
import { api } from "../../../services/api";
import SeccionEvento from "./SeccionEvento";

const iconosCategoria = {
  1: <NightlifeOutlined sx={{ marginRight: "10px" }} />,
  2: <VolunteerActivismOutlined sx={{ marginRight: "10px" }} />,
  3: <SportsBasketballOutlined sx={{ marginRight: "10px" }} />,
  4: <FastfoodOutlined sx={{ marginRight: "10px" }} />,
  5: <BusinessCenterOutlined sx={{ marginRight: "10px" }} />,
  6: <MicExternalOnOutlined sx={{ marginRight: "10px" }} />,
  7: <TheaterComedy sx={{ marginRight: "10px" }} />,
};

const DetailsSection = ({ tipoId, privado, onChange, errores, abierta, onToggle }) => {
  const [tipos, setTipos] = useState([]);
  const [errorTipos, setErrorTipos] = useState(false);

  useEffect(() => {
    const getEventosTipos = async () => {
      try {
        const response = await api.eventos.getAllEventosTipos();
        if (response.status === "success") {
          setTipos(response.data.eventoTipos ?? []);
        } else {
          setErrorTipos(true);
        }
      } catch (error) {
        console.error("Error al obtener los tipos de evento:", error);
        setErrorTipos(true);
      }
    };
    getEventosTipos();
  }, []);

  return (
    <SeccionEvento
      id="detail"
      titulo="Detalles adicionales"
      descripcion="Proporcioná información clave sobre tu evento."
      tieneError={Boolean(errores.eventos_tipos_id || errores.publicoprivado)}
      abierta={abierta}
      onToggle={onToggle}
    >
      <FormControl fullWidth>
        <p className="subtitulo-seccion-evento-expanded">
          Tipo de evento <span className="text-danger">*</span>
        </p>
        <p className="descrip-seccion-evento-expanded">
          Elegí la categoría que mejor describe tu evento.
        </p>

        {errorTipos ? (
          <Alert severity="error">No se pudieron cargar los tipos de evento.</Alert>
        ) : (
          <div className="row">
            {tipos.map((tipo) => (
              <div key={tipo.id} className="col-12 col-md-6 mb-3">
                <button
                  type="button"
                  onClick={() => onChange("eventos_tipos_id", tipo.id)}
                  className={`w-100 ${tipoId === tipo.id ? "boton-tipo-active" : "boton-tipo"}`}
                >
                  <div className="d-flex align-items-center">
                    {iconosCategoria[tipo.id]}
                    <span className="text-left">{tipo.evento_tipo ?? tipo.tipo}</span>
                  </div>
                  <span className="indicator-wrapper">
                    <span className="indicator-fuera"></span>
                    <span className="indicator-dentro"></span>
                  </span>
                </button>
              </div>
            ))}
            {errores.eventos_tipos_id && (
              <div className="col-12">
                <Alert severity="error" className="mb-4">
                  {errores.eventos_tipos_id}
                </Alert>
              </div>
            )}
          </div>
        )}
      </FormControl>

      <FormControl fullWidth>
        <p className="subtitulo-seccion-evento-expanded">
          Visibilidad del evento <span className="text-danger">*</span>
        </p>
        <p className="descrip-seccion-evento-expanded">
          Establecé la accesibilidad de tu evento.
        </p>
        <div className="d-flex flex-wrap flex-row gap-3">
          <button
            type="button"
            onClick={() => onChange("privado", false)}
            className={`mr-2 mb-2 ${privado === false ? "boton-tipo-active" : "boton-tipo"}`}
          >
            <div className="d-flex flex-column">
              <span className="text-left">Evento público</span>
              <span className="descripcion-boton">Todos podrán verlo.</span>
            </div>
            <span className="indicator-wrapper">
              <span className="indicator-fuera"></span>
              <span className="indicator-dentro"></span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => onChange("privado", true)}
            className={`mr-2 mb-2 ${privado === true ? "boton-tipo-active" : "boton-tipo"}`}
          >
            <div className="d-flex flex-column">
              <span className="text-left">Evento privado</span>
              <span className="descripcion-boton text-left">
                Restringido a miembros de la organización.
              </span>
            </div>
            <span className="indicator-wrapper">
              <span className="indicator-fuera"></span>
              <span className="indicator-dentro"></span>
            </span>
          </button>
        </div>
        {errores.publicoprivado && (
          <Alert severity="error" className="my-2">
            {errores.publicoprivado}
          </Alert>
        )}
      </FormControl>
    </SeccionEvento>
  );
};

export default DetailsSection;
